import main from '@set-up/pages/main.vue';
export default [
  {
    path: 'setup',
    name: 'setup',
    component: main,
    redirect: 'setup/channel',
    children: [
      {
        path: 'channel',
        name: 'setup/channel',
        meta: { title: '支付渠道', auth: true },
        component: () => import('@set-up/pages/channel.vue'),
      },
      {
        path: 'merchants',
        name: 'setup/merchants',
        meta: { title: '往来商户', auth: true },
        component: () => import('@set-up/pages/merchants.vue'),
      },
      {
        path: 'rule',
        name: 'setup/rule',
        meta: { title: '分账规则', auth: true },
        component: () => import('@set-up/pages/rule.vue'),
      },
      {
        path: 'switch',
        name: 'setup/switch',
        meta: { title: '审核开关', auth: true },
        component: () => import('@set-up/pages/switch.vue'),
      },
      {
        path: 'develop',
        name: 'setup/develop',
        meta: { title: '开发设置', auth: true },
        component: () => import('@set-up/pages/develop.vue'),
      },
    ],
  },
  {
    path: 'setup/channel/edit',
    name: 'setup/channel/edit',
    meta: { title: '设置参数', auth: true },
    component: () => import('@set-up/pages/channel-edit.vue'),
  },
];
